import {Image} from "@/images/Image.ts";
import {srcUrl} from "@/api/ImageApi.ts";
import {cn} from "@/lib/utils.ts";

export default function DetailPortrait({image, alt, className}: {
    image?: Image;
    alt: string;
    className?: string;
}) {
    if (!image) return null;

    return (
        <aside className={cn(
            "self-start overflow-hidden p-3 @min-[48rem]:sticky @min-[48rem]:top-2 @min-[48rem]:col-start-2 @min-[48rem]:row-start-1",
            className,
        )}>
            <div className="flex max-h-72 items-center justify-center overflow-hidden rounded-xs bg-black/15 shadow-lg shadow-black/25 @min-[48rem]:max-h-136">
                <img draggable="false"
                     alt={alt}
                     className="max-h-68 w-full select-none object-contain @min-[48rem]:max-h-128"
                     src={srcUrl(image)}/>
            </div>
        </aside>
    );
}
